import {connect} from 'react-redux'
import PayAnyBill from '../components/PayAnyBillView'
import _ from 'lodash'

import {changeStep} from "../../../../layouts/Content/modules/step";
import {appSetVal, appSetObj, appSetServerVal, checkFields, appCall} from '../../../../store/application'
import {setPaymentOption, updateAmounts, submitTransaction, getAccounts, sendBillImage} from "../modules/billpayment";
import {resetScannerResult} from "../../../Devices/Scanner/modules/scanner";

const mapDispatchToProps = {
  setPaymentOption: setPaymentOption,
  updateAmounts: updateAmounts,
  getAccounts: getAccounts,
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  appSetServerVal: appSetServerVal,
  changeStep: changeStep,
  checkFields: checkFields,
  appCall: appCall,
  submitTransaction: submitTransaction,
  resetScannerResult: resetScannerResult,
  sendBillImage: sendBillImage
};

const mapStateToProps = (state) => {
  const {biller_name, icon, payment_options, fee_id, payment_option_type, original_amount, fee, stored_accounts,
    check_account_success, check_account_done, requested_amount, discount_amount, customer_limit_amount, init_payment_done,
    init_payment_success, ready_to_submit, account, confirm_account, isAccountFieldsEqual, scanner_account_error, bill_image_processing, display_amount
  } = state.app.x_data;

  const {imageFront, imageBack} = state.scanner;

  const {customer_id} = state.customer;

  const requiredFields = {};

  _.each(state.app.x_data, (v, f) => {
    if(/required_/.test(f)){{
      requiredFields[f] = state.app.x_data[f]
    }}
  });

  return {
    biller_name,
    account: account,
    confirm_account: confirm_account,
    account_scanner: state.scanner.account,
    isAccountFieldsEqual,
    icon,
    payment_options,
    fee_id,
    payment_option_type,
    ...requiredFields,
    original_amount,
    requested_amount,
    discount_amount,
    display_amount,
    customer_limit_amount,
    fee,
    customer_id,
    stored_accounts,
    check_account_error: check_account_done && !check_account_success,
    check_init_payment_error: init_payment_done && !init_payment_success,
    ready_to_submit: !ready_to_submit,
    scanned_image_front: imageFront,
    scanned_image_back: imageBack,
    scanner_account_error,
    bill_image_processing
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PayAnyBill)


// WEBPACK FOOTER //
// ./src/components/Applications/PayAnyBill/containers/PayAnyBillContainer.js